<template>
    <div class="module">
        <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
            <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{checkedRegion.name}}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
            </div>
            <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{checkedStore.name}}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
            </div>
        </div>
        <div class="select-box">
            <div class="date-box  flex-row  flex-between">
                <div class="date">
                    <div class="arrow-box" @click="handleCalendar('prev')">
                        <div class="arrow-l"></div>
                    </div>
                    <div>{{year}}年{{month}}月</div>
                    <div class="arrow-box" @click="handleCalendar('next')">
                        <div class="arrow-r"></div>
                    </div>
                </div>
            </div>
        </div>
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="main-box">
                <div class="top-box flex flex-between flex-y-center">
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{orderData.waitTotal}}</div>
                        <div class="top-tit">待解决</div>
                        <div class="top-sign blue"></div>
                    </div>
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{orderData.solveTotal}}</div>
                        <div class="top-tit">已解决</div>
                        <div class="top-sign green"></div>
                    </div>
                    <div class="top-item flex-y-center flex-col">
                        <div class="top-num">{{orderData.rate}}%</div>
                        <div class="top-tit">完成率</div>
                        <div class="top-sign yellow"></div>
                    </div>
                </div>
                <div class="list-box">
                    <div class="title">
                        工单事件
                    </div>
                    <div class="list-item">
                        <div class="flex flex-y-center flex-col" @click="toOrderList(3)">
                            <div class="list-inner flex flex-start flex-y-center">
                                <img class="list-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-12-05/remind.png" />
                                <div class="flex-1 list-tit">
                                    投诉平均处理时长
                                </div>
                                <div class="list-num">{{orderData.complaint}}小时</div>
                            </div>
                            <div class="list-txt-box flex flex-start">
                                <div class="list-txt-tit">待解决：</div>
                                <div class="list-txt-num">{{orderData.waitComplaint}}</div>
                                <div class="list-txt-tit">已解决：</div>
                                <div class="list-txt-num">{{orderData.solveComplaint}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="list-item">
                        <div class="flex flex-y-center flex-col" @click="toOrderList(1)">
                            <div class="list-inner flex flex-start flex-y-center">
                                <img class="list-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-12-05/remind.png" />
                                <div class="flex-1 list-tit">
                                    反馈平均处理时长
                                </div>
                                <div class="list-num">{{orderData.feedback}}小时</div>
                            </div>
                            <div class="list-txt-box flex flex-start">
                                <div class="list-txt-tit">待解决：</div>
                                <div class="list-txt-num">{{orderData.waitFeedback}}</div>
                                <div class="list-txt-tit">已解决：</div>
                                <div class="list-txt-num">{{orderData.solveFeedback}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="list-item">
                        <div class="flex flex-y-center flex-col" @click="toOrderList(4)">
                            <div class="list-inner flex flex-start flex-y-center">
                                <img class="list-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-12-05/remind.png" />
                                <div class="flex-1 list-tit">
                                    满意度服务平均处理时长
                                </div>
                                <div class="list-num">{{ orderData.satisfaction }}小时</div>
                            </div>
                            <div class="list-txt-box flex flex-start">
                                <div class="list-txt-tit">待解决：</div>
                                <div class="list-txt-num">{{ orderData.waitSatisfaction }}</div>
                                <div class="list-txt-tit">已解决：</div>
                                <div class="list-txt-num">{{ orderData.solveSatisfaction }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 区经区总 切换区域 -->
            <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
            </van-popup>
            <!-- 区经区总 切换门店 -->
            <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
            </van-popup>
        </van-pull-refresh>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from 'vant'
import { keepAliveAfterHandler } from "@/router/router";
import Picker from '@/components/Picker';
import { mapState } from 'vuex'
import { getCookie } from '@/utils'
import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

export default {
    inject: ['reload'],
    name: 'repairOrderHome',
    components: {
        Picker
    },
    data() {
        return {
            pickerType: 'month',// 日期控件类型
            refreshing: false,//刷新
            page: 1,
            total: 0,
            orderData: {},//工单数据
            showTimePopup: false,//选择时间弹窗
            year: "",
            month: "",
            postId: 0, // 岗位
            showRegionPopup: false,
            showRegionStorePopup: false,
            regionStoreList: [],//区域门店列表
            regionList: [],//区域列表
            checkedRegion: { id: -1, name: '' },//所选区域
            checkedStore: {  //所选门店
                name: '',
                id: -1,
            },
        }
    },
    computed: {
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
    },
    beforeRouteLeave(to, from, next) {
        keepAliveAfterHandler.call(this, to, from)
        next()
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        // 获取当前登陆人所记录的区域门店信息
        getUserLogin().then((res) => {
            if (this.regionPostId.includes(this.postId)) {
                this.checkedRegion.name = res.data.region?.storeName // 当前区域
                this.checkedRegion.id = res.data.region?.id
                if (res.data.store) {
                    this.checkedStore.name = res.data.store.storeName //当前门店
                    this.checkedStore.id = res.data.store.id
                    // 门店列表
                    let params = {
                        id: this.checkedRegion.id
                    }
                    getRegionStoreList(params).then((res) => {
                        this.regionStoreList = res.data
                    })
                }
                // 区域列表
                getRegionStoreList().then((res) => {
                    this.regionList = res.data
                })
            }
            this.initdateData();
        })
    },
    methods: {
        // 初始化时间
        initdateData() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            this.year = year
            this.month = month
            this.getOrderData(year, month)
        },
        // 获取列表
        getOrderData(year, month) {
            let params = {
                newDate: year + "-" + month,
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id,
            }
            request({
                url: "/work/workNoData?newDate=" + year + "-" + month,
                method: "get",
                params: params
            })
                .then((res) => {
                    this.orderData = res.data
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 切换月份
        handleCalendar(handle) {
            this.page = 1;
            const year = this.year;
            const month = this.month;
            this.bookingData = [];
            if (handle === "prev") {
                let newMonth = month - 1;
                let newYear = year;
                if (newMonth < 1) {
                    newYear = year - 1;
                    newMonth = 12;
                }
                this.getOrderData(newYear, newMonth);
                this.year = newYear
                this.month = newMonth
            } else {
                let newMonth = month + 1;
                let newYear = year;
                if (newMonth > 12) {
                    newYear = year + 1;
                    newMonth = 1;
                }
                this.getOrderData(newYear, newMonth);
                this.year = newYear
                this.month = newMonth
            }
        },
        //  跳转工单列表
        toOrderList(workNoType) {
            this.$router.push({
                name: 'repairOrderList', query: {
                    workNoType, year: this.year, month: this.month,
                    id: this.checkedRegion.id, storeId: this.checkedStore.id
                }
            });
        },
        onRefresh() {
            // // 将 loading 设置为 true，表示处于加载状态
            this.bookingData = [];
            this.refreshing = false;
            this.getOrderData(this.year, this.month)
        },
        // 筛选区域门店相关
        openRegionPopup() {
            this.showRegionPopup = true
        },
        onRegionChange(data) {
            this.checkedRegion = data
            this.showRegionPopup = false
            this.$nextTick(() => {
                // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                this.checkedStore.id = 0
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then((res) => {
                    this.onRefresh();
                })
            })
        },
        openRegionStorePopup() {
            this.showRegionStorePopup = true
        },
        onRegionStoreChange(data) {
            this.showRegionStorePopup = false
            this.checkedStore = data
            let params = {
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id
            }
            saveRegionStore(params).then(() => {
                this.onRefresh();
            })
        },
    },
}
</script>

<style scoped lang="less">
.ml-20 {
    margin-left: 20px;
}

::-webkit-scrollbar {
    display: none;
}

.module {
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;
}

.select-box {
    width: 310px;
    padding: 50px 30px 30px 30px;
    margin: 0 auto;
    .date {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: -6px 0;
        font-family: "PingFangSC-Medium";
        font-size: 30px;
        color: #35434c;
    }
    .arrow-l {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-right: 30px;
    }
    .arrow-r {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-left: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-left: 30px;
    }
}
.main-box {
    min-height: calc(100vh - 102px);
    // padding-bottom: 130px;
    padding: 30px 30px;
}
.top-box {
    margin-bottom: 50px;
    .top-item {
        width: 200px;
        height: 128px;
        background: #ffffff;
        box-shadow: 4px 5px 20px 0px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        position: relative;
        justify-content: center;
        overflow: hidden;
    }
    .top-num {
        font-size: 36px;
        font-weight: 700;
        color: #35434c;
    }
    .top-tit {
        font-size: 26px;
        font-weight: 400;
        color: #a0acb5;
    }
    .top-sign {
        position: absolute;
        right: -25px;
        bottom: -25px;
        width: 70px;
        height: 70px;
        border-radius: 50%;
    }
    .top-sign.blue {
        background: #4a6be6;
    }
    .top-sign.green {
        background: #4bca85;
    }
    .top-sign.yellow {
        background: #f3d168;
    }
}
.list-box {
    padding-bottom: 50px;
    .title {
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        margin-bottom: 40px;
    }
    .list-item {
        width: 690px;
        height: 163px;
        background: #fafafe;
        border-radius: 10px;
        padding: 30px 20px;
        margin-bottom: 20px;
        .list-inner {
            width: 100%;
            margin-bottom: 20px;
        }
        .list-icon {
            width: 50px;
            max-height: 50px;
            margin-right: 25px;
        }
        .list-tit {
            font-size: 30px;
            font-weight: 400;
            color: #35434c;
        }
        .list-num {
            font-size: 30px;
            font-weight: 400;
            color: #35434c;
        }
        .list-txt-box {
            width: 100%;
            margin-left: 90px;
            font-size: 26px;
            font-weight: 400;
            color: #a0acb5;
        }
        .list-txt-tit {
            width: 110px;
        }
        .list-txt-num {
            width: 80px;
            color: #35434c;
        }
    }
}
.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}

.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}
:deep(.van-popup__close-icon--top-right) {
    top: 50px;
}
.store-box {
    padding: 30px 30px;
    padding-bottom: 0;
    background-color: #fff;
    .store-arrow {
        width: 16px;
        height: 26px;
        margin-left: 8px;
        margin-top: 3px;
    }
    .region-name-box {
        min-width: 239px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        margin-right: 10px;
        padding: 10px 15px 11px 16px;
    }
    .store-name-box {
        min-width: 187px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        padding: 10px 15px 11px 16px;
    }
    .name-txt {
        color: #66757f;
        font-size: 26px;
    }
}
</style>
